export function getTpid(): string {
  let cookie = document.cookie.split(';')
    .find(cook => cook.includes('tp_id='))

  if (cookie) {
    cookie = cookie.split('=')[1].trim()
  }

  return cookie
}
